export function getFileParts(fullFileName: string) {
    const fileParts = fullFileName.split('.');
    let extension = '';
    if (fileParts.length > 1) {
        extension = '.' + fileParts.pop();
    }
    const fileName = fileParts.join('.');
    return { fileName: fileName, extension: extension };
}
